import React from "react";
import {WelcomeSloganField} from "./WelcomeSloganField";
import {ThemesField} from "./ThemesField";
import {LogicalToggleField} from "../../form-components/LogicalToggleField";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {setBannerIconVisible} from "../../../../../slices/personalizationSlice";
import {setCmsInEditMode} from "../../../../../slices/globalParamsSlice";
import {Banner} from "../../dishes-categories/menu-item/preview/menu-item-details/Banner";

export const PersonalizationForm = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {bannerIconVisible} = useSelector(state => state.personalization.form);

    const handleIconVisibleChange = () => {
        dispatch(setBannerIconVisible(!bannerIconVisible));
        dispatch(setCmsInEditMode(true));
    }

    return (
        <>
            <WelcomeSloganField/>
            <ThemesField/>
            <LogicalToggleField id={'toggleIconBanner'}
                                name={t('showBannerIcon')}
                                value={bannerIconVisible}
                                onChange={handleIconVisibleChange}
                                customMessageTrue={<Banner name={t('bestseller')}
                                                           manualIconToggle={true}
                                                           iconPath={`${process.env.PUBLIC_URL}/theme/icons/bestseller-small.svg`}/>}
                                customMessageFalse={<Banner name={t('bestseller')}/>}/>
        </>
    );
}